<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('单号')" prop="orderNo">
                <a-input v-model="queryParam.orderNo" @pressEnter="handleQuery" :maxLength="32" :placeholder="$t('请输入')+$t('单号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('联系人')" prop="contactName">
                <a-input v-model="queryParam.contactName" @pressEnter="handleQuery" :maxLength="32" :placeholder="$t('请输入')+$t('联系人')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('联系电话')" prop="contactPhone">
                <a-input v-model="queryParam.contactPhone" @pressEnter="handleQuery" :maxLength="20" :placeholder="$t('请输入')+$t('联系电话')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('预约方式')" prop="appointType">
                <a-select v-model="queryParam.appointType" :placeholder="$t('请选择')+$t('预约方式')" allow-clear>
                  <a-select-option :value="10">{{ $t('到店') }}</a-select-option>
                  <a-select-option :value="20">{{ $t('上门') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('状态')" prop="status">
                <a-select v-model="queryParam.status" :placeholder="$t('请选择')+$t('状态')" allow-clear>
                  <a-select-option :value="1200">{{ $t('待报价') }}</a-select-option>
                  <a-select-option :value="1210">{{ $t('已报价') }}</a-select-option>
                  <a-select-option :value="1230">{{ $t('已结算') }}</a-select-option>
                  <a-select-option :value="1250">{{ $t('已取消') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 报价抽屉 -->
      <quote-form ref="quoteForm" @ok="getList" />
      <!-- 结算抽屉 -->
      <settle-form ref="settleForm" @ok="getList" />
      <!-- 详情抽屉 -->
      <a-drawer width="480" :visible="detailVisible" @close="detailVisible = false">
        <a-divider orientation="left"><b>{{ $t('回收预约详情') }}</b></a-divider>
        <a-descriptions :column="1" bordered size="small" v-if="detail">
          <a-descriptions-item :label="$t('单号')">{{ detail.orderNo }}</a-descriptions-item>
          <a-descriptions-item :label="$t('回收门店')">{{ detail.storeName }}</a-descriptions-item>
          <a-descriptions-item :label="$t('预约方式')">{{ detail.appointTypeName }}</a-descriptions-item>
          <a-descriptions-item :label="$t('联系人')">{{ detail.contactName }}</a-descriptions-item>
          <a-descriptions-item :label="$t('联系电话')">{{ detail.contactPhone }}</a-descriptions-item>
          <a-descriptions-item :label="$t('预约时间')">{{ parseTime(detail.appointTime) }}</a-descriptions-item>
          <a-descriptions-item :label="$t('地址')">{{ detail.address }}</a-descriptions-item>
          <a-descriptions-item :label="$t('物品描述')">{{ detail.categoryDesc }}</a-descriptions-item>
          <a-descriptions-item :label="$t('用户备注')">{{ detail.userRemark }}</a-descriptions-item>
          <a-descriptions-item :label="$t('状态')">{{ detail.statusName }}</a-descriptions-item>
          <a-descriptions-item :label="$t('报价金额')">{{ detail.quoteAmount }}</a-descriptions-item>
          <a-descriptions-item :label="$t('报价备注')">{{ detail.quoteRemark }}</a-descriptions-item>
          <a-descriptions-item :label="$t('报价时间')">{{ parseTime(detail.quoteTime) }}</a-descriptions-item>
          <a-descriptions-item :label="$t('结算金额')">{{ detail.settleAmount }}</a-descriptions-item>
          <a-descriptions-item :label="$t('结算时间')">{{ parseTime(detail.settleTime) }}</a-descriptions-item>
          <a-descriptions-item :label="$t('处理备注')">{{ detail.handleRemark }}</a-descriptions-item>
          <a-descriptions-item :label="$t('创建时间')">{{ parseTime(detail.createTime) }}</a-descriptions-item>
        </a-descriptions>
        <div v-if="detail && detail.images" style="margin-top: 12px;">
          <a-divider orientation="left"><b>{{ $t('物品图片') }}</b></a-divider>
          <img v-for="(img, idx) in detail.images.split(',')" :key="idx" :src="img" style="width:80px;height:80px;margin:4px;" alt="img"/>
        </div>
      </a-drawer>
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1200 }"
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag :color="statusColor(record.status)">{{ record.statusName }}</a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)"><a-icon type="eye" />{{$t('详情')}}</a>
          <template v-if="record.status === 1200">
            <a-divider type="vertical" v-hasPermi="['recycle:order:quote']" />
            <a @click="$refs.quoteForm.open(record)" v-hasPermi="['recycle:order:quote']">
              <a-icon type="dollar" />{{$t('报价')}}
            </a>
          </template>
          <template v-if="record.status === 1210">
            <a-divider type="vertical" v-hasPermi="['recycle:order:settle']" />
            <a @click="$refs.settleForm.open(record)" v-hasPermi="['recycle:order:settle']">
              <a-icon type="pay-circle" />{{$t('结算')}}
            </a>
          </template>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageRecycleOrder, getRecycleOrder } from '@/api/recycle/order'
import { mapGetters } from 'vuex'
import QuoteForm from './modules/QuoteForm'
import SettleForm from './modules/SettleForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'RecycleOrder',
  components: {
    QuoteForm,
    SettleForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      detailVisible: false,
      detail: null,
      loading: false,
      total: 0,
      queryParam: {
        orderNo: null,
        contactName: null,
        contactPhone: null,
        appointType: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('单号'),
          dataIndex: 'orderNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('回收门店'),
          dataIndex: 'storeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('预约方式'),
          dataIndex: 'appointTypeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('联系人'),
          dataIndex: 'contactName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('联系电话'),
          dataIndex: 'contactPhone',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('报价金额'),
          dataIndex: 'quoteAmount',
          align: 'center'
        },
        {
          title: this.$t('结算金额'),
          dataIndex: 'settleAmount',
          align: 'center'
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    statusColor(status) {
      switch (status) {
        case 1200: return 'orange'
        case 1210: return 'blue'
        case 1230: return 'green'
        case 1250: return 'red'
        default: return 'default'
      }
    },
    /** 查询回收预约单列表 */
    getList () {
      this.loading = true
      pageRecycleOrder(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 详情 */
    handleDetail (record) {
      getRecycleOrder({ "id": record.id }).then(response => {
        this.detail = response.data
        this.detailVisible = true
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        orderNo: undefined,
        contactName: undefined,
        contactPhone: undefined,
        appointType: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>
